import { ButtonBase } from '@mui/material';
import { styled } from '@mui/material/styles';

export const TriggerButtonStyled = styled(ButtonBase)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  padding: theme.spacing(0.5, 1),
  borderRadius: Number(theme.shape.borderRadius) * 2,
  color: theme.palette.common.white,
  transition: theme.transitions.create('background-color'),
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.08)',
  },
}));
